import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import { ClerkProviderWrapper } from "@/components/ClerkProviderWrapper";
import { AuditProvider } from "@/contexts/AuditContext";
import { MembersAuthProvider } from "./contexts/MembersAuthContext";
import { AnimatedRoutes } from "@/components/AnimatedRoutes";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { BackToTopButton } from "@/components/BackToTopButton";
import { CookieConsentBanner } from "@/components/CookieConsentBanner";

const queryClient = new QueryClient();

const App = () => (
  <ClerkProviderWrapper>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <AuditProvider>
            <MembersAuthProvider>
              <ScrollProgressIndicator />
              <Toaster />
              <Sonner />
              <AnimatedRoutes />
              <BackToTopButton />
              <CookieConsentBanner />
            </MembersAuthProvider>
          </AuditProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ClerkProviderWrapper>
);

export default App;
